import { render, staticRenderFns } from "./GestionValoraciones.vue?vue&type=template&id=509d1fc7&scoped=true"
import script from "./GestionValoraciones.vue?vue&type=script&lang=js"
export * from "./GestionValoraciones.vue?vue&type=script&lang=js"
import style0 from "./GestionValoraciones.vue?vue&type=style&index=0&id=509d1fc7&prod&lang=sass"
import style1 from "./GestionValoraciones.vue?vue&type=style&index=1&id=509d1fc7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509d1fc7",
  null
  
)

export default component.exports